export function formatTime(timestamp: string, locale?: string): string {
	try {
		const date = new Date(timestamp);
		if (Number.isNaN(date.getTime())) return "";

		const now = new Date();
		const yesterday = new Date(now);
		yesterday.setDate(now.getDate() - 1);

		const isToday = date.toDateString() === now.toDateString();
		const isYesterday = date.toDateString() === yesterday.toDateString();

		const timeFormatter = new Intl.DateTimeFormat(locale, {
			hour: "numeric",
			minute: "2-digit",
		});
		const time = timeFormatter.format(date);

		if (isToday) {
			return time;
		}

		if (isYesterday) {
			const rtf = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });
			const relativeDate = rtf.format(-1, "day");

			const relativeDateCap =
				relativeDate.charAt(0).toUpperCase() + relativeDate.slice(1);

			return `${relativeDateCap}, ${time}`;
		}

		const dateFormatter = new Intl.DateTimeFormat(locale, {
			year: date.getFullYear() !== now.getFullYear() ? "numeric" : undefined,
			month: "short",
			day: "numeric",
		});
		const dateStr = dateFormatter.format(date);

		return `${dateStr}, ${time}`;
	} catch {
		return "";
	}
}
